import React from 'react';
import { ILLUSTRATIONS } from '../../Constants/Images.constants';
import { Illustration } from './index';

type IllustrationBannerProps = {
  count?: number;
  exclude?: string[];
};

export const filterIllustations = (excludes: string[]) =>
  Object.keys(ILLUSTRATIONS).filter((key) => !excludes.includes(key));

const IllustrationBanner = ({
  count = Object.keys(ILLUSTRATIONS).length,
  exclude = [],
}: IllustrationBannerProps) => {
  // Set list to length of count
  const list = filterIllustations(exclude);
  list.length = count;

  return (
    <>
      {list.map((sport: string, index) => (
        <Illustration key={index} svg={ILLUSTRATIONS[sport]} />
      ))}
    </>
  );
};

export default IllustrationBanner;
